<div class="confirmation-dialog" data-testid="cancel-reason-dialog">
  <div class="dialog-title-bar">
    <h2 class="dialog-title" data-testid="cancel-reason-dialog-title">Cancel Job</h2>
    <button class="close-btn" type="button" aria-label="Close dialog" (click)="onClose()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M6.36436 19.0588L4.96436 17.6588L10.5644 12.0588L4.96436 6.45884L6.36436 5.05884L11.9644 10.6588L17.5644 5.05884L18.9644 6.45884L13.3644 12.0588L18.9644 17.6588L17.5644 19.0588L11.9644 13.4588L6.36436 19.0588Z"
          fill="white"
        />
      </svg>
    </button>
  </div>

  <mat-dialog-content class="dialog-body">
    <p id="cancel-reason-label" class="cancel-job-reason__label" data-testid="cancel-reason-label">
      Reason behind your cancellation:<span aria-hidden="true">*</span>
    </p>

    <mat-form-field appearance="outline" class="cancel-job-reason__field">
      <textarea
        matInput
        [formControl]="reasonControl"
        [attr.maxlength]="maxLength"
        rows="5"
        data-testid="cancel-reason-input"
        required
        aria-labelledby="cancel-reason-label"
        [attr.aria-describedby]="
          hasRequiredError
            ? 'cancel-reason-counter cancel-reason-error'
            : 'cancel-reason-counter'
        "
      ></textarea>
    </mat-form-field>

    <div class="cancel-job-reason__meta" data-testid="cancel-reason-meta">
      <p id="cancel-reason-counter" class="cancel-job-reason__counter" data-testid="cancel-reason-counter">
        {{ remainingCharacters() }} characters remaining
      </p>
      @if (hasRequiredError) {
        <p id="cancel-reason-error" class="cancel-job-reason__error" data-testid="cancel-reason-error">
          Cancellation reason is required.
        </p>
      }
    </div>

    <p class="cancel-job-reason__confirm-question" data-testid="cancel-reason-confirm-question">
      Are you sure you want to cancel this translation job?
    </p>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button
      type="button"
      class="btn btn-outline"
      data-testid="cancel-confirm-no"
      (click)="onClose()"
    >
      No
    </button>
    <button
      type="button"
      class="btn btn-primary"
      data-testid="cancel-confirm-yes"
      [disabled]="reasonControl.invalid"
      (click)="onConfirm()"
    >
      Yes
    </button>
  </mat-dialog-actions>
</div>
